import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Opt a single request out of `ErrorInterceptor`'s global error navigation.
 *
 * By default a failed request sends the user to `/error` (or `/unauthorized` on a 401). That is the
 * right default for a request whose failure the user can do nothing about, but it makes a
 * component's own error state unreachable: the navigation tears the component down before it can
 * render "not found" / "unable to load". Setting this token leaves the error to propagate to the
 * caller untouched, so the screen that issued the request owns the failure UI.
 *
 * The error is still rethrown either way — this only suppresses the *navigation*, never the error
 * itself, so nothing swallows a failure silently.
 */
export const SUPPRESS_GLOBAL_ERROR_NAVIGATION = new HttpContextToken<boolean>(() => false);

/**
 * A fresh {@link HttpContext} with {@link SUPPRESS_GLOBAL_ERROR_NAVIGATION} set, for a service that
 * renders its own error state. Returns a new instance per call — an `HttpContext` belongs to one
 * request, so sharing one across requests would couple them.
 */
export function suppressGlobalErrorNavigation(): HttpContext {
  return new HttpContext().set(SUPPRESS_GLOBAL_ERROR_NAVIGATION, true);
}
